import { Action } from '@ngrx/store';
import { PMCreateActions } from '../actions/pm-create.action';
import { PMCreateDetail } from '../models/pm-create-detail.model';
 

export const createPMDetail = '[PM] Create Detail';
export const createPMEquipment = '[PM] Create Equipment';
export const RESET = 'RESET';

export function pmReducer(state: PMCreateDetail = null, action: PMCreateActions) {
  switch (action.type) {
    case createPMDetail:
      return action.payload;
    case createPMEquipment:
      return {...state, pmequipmentListModel: action.payload  }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/reducers/pm-create.reducer.ts